import React from 'react';
import { Link } from 'react-router-dom';

function CTA({ title, subtitle, buttonText, buttonLink }) {
  return (
    <section className="bg-[#b87c4c] py-16 px-4">
      <div className="max-w-4xl mx-auto text-center">
        <h2 className="text-3xl md:text-4xl font-bold text-white mb-4">
          {title}
        </h2>
        <p className="text-xl text-white/90 mb-8">
          {subtitle}
        </p>
        <Link
          to={buttonLink}
          className="inline-block px-8 py-4 bg-[#8B4513] text-white font-semibold rounded-lg shadow-lg hover:bg-[#6B3410] transition-colors duration-200"
        >
          {buttonText}
        </Link>
      </div>
    </section>
  );
}

export default CTA; 